var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9315 23.8988H18.0303C19.4844 23.8988 20.4585 22.4094 19.8797 21.0753L18.002 16.7694V10.0776C18.0091 6.85176 15.2844 4 11.9315 4C8.57146 4 5.85381 6.72471 5.85381 10.0776V16.7694L3.97617 21.0753C3.39734 22.4094 4.37146 23.8988 5.82558 23.8988H11.9244",
    fill: "#2222B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.369006 20.2919C-0.830994 15.4213 1.27254 11.1013 1.35724 10.9248L2.91724 11.6942L2.14077 11.306L2.91724 11.6942C2.89606 11.7366 1.01136 15.6401 2.05606 19.8754L0.369006 20.2919Z",
    fill: "#00B9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.557 20.2919L21.87 19.8754C22.9147 15.6119 21.03 11.7295 21.0088 11.6942L22.5688 10.9248C22.6606 11.1083 24.757 15.4213 23.557 20.2919Z",
    fill: "#00B9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55979 25.6353C9.55979 26.9411 10.6186 28 11.9245 28C13.2304 28 14.2892 26.9411 14.2892 25.6353H9.55273H9.55979Z",
    fill: "#00B9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e9fb2a6dbb6b536b78da3ce2811e3378.svg";
export { ForwardRef as ReactComponent };